"use client";

import { c as _c } from "react/compiler-runtime";
import { FallbackImage } from "@/components/common/FallbackImage";
import { ImageMediaModal, requestCenteredImageFullscreen } from "@/components/drops/view/item/content/media/ImageMediaModal";
import { InlineMediaActions } from "@/components/drops/view/item/content/media/MediaActionToolbar";
import { useMediaActions } from "@/components/drops/view/item/content/media/useMediaActions";
import { useDropImageGallery } from "@/components/drops/view/part/DropImageGalleryProvider";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import useCapacitor from "@/hooks/useCapacitor";
import React, { useCallback, useRef, useState } from "react";
function NaturalHeightImage(t0) {
  const $ = _c(17);
  const {
    imgRef,
    primarySrc,
    fallbackSrc,
    retryTick,
    onLoad,
    onFinalError,
    imageObjectPosition
  } = t0;
  const [aspectRatio, setAspectRatio] = useState();
  let t1;
  if ($[0] !== onLoad) {
    t1 = event => {
      const {
        naturalHeight,
        naturalWidth
      } = event.currentTarget;
      if (naturalHeight > 0 && naturalWidth > 0) {
        setAspectRatio(`${naturalWidth} / ${naturalHeight}`);
      }
      onLoad();
    };
    $[0] = onLoad;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleLoad = t1;
  let t2;
  if ($[2] !== aspectRatio) {
    t2 = {
      aspectRatio,
      maxHeight: "16rem"
    };
    $[2] = aspectRatio;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== imageObjectPosition) {
    t3 = {
      objectPosition: imageObjectPosition
    };
    $[4] = imageObjectPosition;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== fallbackSrc || $[7] !== handleLoad || $[8] !== imgRef || $[9] !== onFinalError || $[10] !== primarySrc || $[11] !== retryTick || $[12] !== t3) {
    t4 = <FallbackImage key={retryTick} ref={imgRef} primarySrc={primarySrc} fallbackSrc={fallbackSrc} alt="Drop media" fill={true} sizes="(max-width: 768px) 100vw, 768px" optimize={false} className="tw-object-contain" style={t3} onLoad={handleLoad} onError={onFinalError} />;
    $[6] = fallbackSrc;
    $[7] = handleLoad;
    $[8] = imgRef;
    $[9] = onFinalError;
    $[10] = primarySrc;
    $[11] = retryTick;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t2 || $[15] !== t4) {
    t5 = <span className="tw-relative tw-block tw-min-h-px tw-w-full tw-max-w-full tw-overflow-hidden" style={t2}>{t4}</span>;
    $[14] = t2;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}
export default function WaveDropPartContentMediaImage(t0) {
  const $ = _c(45);
  const {
    src,
    imageScale: t1,
    imageObjectPosition: t2,
    galleryItemId
  } = t0;
  const imageScale = t1 === undefined ? ImageScale.AUTOx450 : t1;
  const imageObjectPosition = t2 === undefined ? "center" : t2;
  const [loaded, setLoaded] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errorCount, setErrorCount] = useState(0);
  const [retryTick, setRetryTick] = useState(0);
  const {
    isCapacitor
  } = useCapacitor();
  const imageGallery = useDropImageGallery();
  const imgRef = useRef(null);
  const modalImageRef = useRef(null);
  let t3;
  if ($[0] !== src) {
    t3 = {
      url: src,
      fallbackFileName: "image",
      dialogTitle: "Save image",
      mimeType: "image"
    };
    $[0] = src;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const {
    downloadMedia,
    isDownloading,
    openLabel,
    openMedia
  } = useMediaActions(t3);
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setLoaded(true);
    };
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const handleImageLoad = t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setErrorCount(1);
    };
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const handleError = t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setLoaded(false);
      setErrorCount(0);
      setRetryTick(_temp);
    };
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const manualRetry = t6;
  let t7;
  if ($[5] !== galleryItemId || $[6] !== imageGallery) {
    t7 = event => {
      event.stopPropagation();
      if (galleryItemId && imageGallery?.openImage(galleryItemId)) {
        return;
      }
      setIsModalOpen(true);
    };
    $[5] = galleryItemId;
    $[6] = imageGallery;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const handleOpenModal = t7;
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      setIsModalOpen(false);
    };
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const handleCloseModal = t8;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      const fullscreenTarget = modalImageRef.current ?? imgRef.current;
      if (fullscreenTarget) {
        requestCenteredImageFullscreen(fullscreenTarget);
      }
    };
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const handleFullScreen = t9;
  if (errorCount > 0) {
    let t10;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-px-4 tw-py-8"><span className="tw-text-sm tw-text-iron-400">Couldn’t load image.</span><button type="button" onClick={manualRetry} className="tw-rounded-md tw-bg-iron-700 tw-px-3 tw-py-1 tw-text-xs tw-text-white hover:tw-bg-iron-600">Retry</button></div>;
      $[10] = t10;
    } else {
      t10 = $[10];
    }
    return t10;
  }
  const t10 = !isCapacitor;
  let t11;
  if ($[11] !== downloadMedia || $[12] !== isDownloading || $[13] !== openLabel || $[14] !== openMedia || $[15] !== t10) {
    t11 = <InlineMediaActions variant="image" onOpen={openMedia} openLabel={openLabel} onDownload={downloadMedia} isDownloading={isDownloading} onFullscreen={handleFullScreen} fullscreenTargetAvailable={t10} />;
    $[11] = downloadMedia;
    $[12] = isDownloading;
    $[13] = openLabel;
    $[14] = openMedia;
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== imageScale || $[18] !== src) {
    t12 = getScaledImageUri(src, imageScale);
    $[17] = imageScale;
    $[18] = src;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== imageObjectPosition || $[21] !== retryTick || $[22] !== src || $[23] !== t12) {
    t13 = <NaturalHeightImage key={retryTick} imgRef={imgRef} primarySrc={t12} fallbackSrc={src} retryTick={retryTick} onLoad={handleImageLoad} onFinalError={handleError} imageObjectPosition={imageObjectPosition} />;
    $[20] = imageObjectPosition;
    $[21] = retryTick;
    $[22] = src;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== handleOpenModal || $[26] !== t13) {
    t14 = <button type="button" onClick={handleOpenModal} aria-label="Open drop media" className="tw-block tw-w-full tw-cursor-pointer tw-border-0 tw-bg-transparent tw-p-0">{t13}</button>;
    $[25] = handleOpenModal;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t11 || $[29] !== t14) {
    t15 = <div className="tw-relative tw-w-full tw-min-w-0">{t11}{t14}</div>;
    $[28] = t11;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== loaded) {
    t16 = !loaded && <div className="tw-sr-only" aria-live="polite">Loading image</div>;
    $[31] = loaded;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== downloadMedia || $[34] !== isCapacitor || $[35] !== isDownloading || $[36] !== isModalOpen || $[37] !== openLabel || $[38] !== openMedia || $[39] !== src) {
    t17 = isModalOpen && <ImageMediaModal src={src} imageRef={modalImageRef} onClose={handleCloseModal} onOpen={openMedia} openLabel={openLabel} onDownload={downloadMedia} isDownloading={isDownloading} onFullscreen={handleFullScreen} fullscreenTargetAvailable={!isCapacitor} />;
    $[33] = downloadMedia;
    $[34] = isCapacitor;
    $[35] = isDownloading;
    $[36] = isModalOpen;
    $[37] = openLabel;
    $[38] = openMedia;
    $[39] = src;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t15 || $[42] !== t16 || $[43] !== t17) {
    t18 = <>{t15}{t16}{t17}</>;
    $[41] = t15;
    $[42] = t16;
    $[43] = t17;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  return t18;
}
function _temp(currentTick) {
  return currentTick + 1;
}